import { Panel, PanelType } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import React, { Component } from 'react';
import '../../css/immocom.css';
import { DataSociete } from '../../data/DataSociete';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/*
******************************************************************************************************
PROPS :
    ATTRIBUTS :
        int     idSociete                   id de la société
        bool    isOpen                      détermine si panel ouvert ou non

    METHODES :
        void    onDismiss                   méthode appelée lorsque l'utilisateur clique sur "Annuler"
        void    onMiseAJour                 méthode appelée lorsque l'utilisateur clique sur "Valider" ou "Supprimer"
******************************************************************************************************
*/

export class FicheParametresPush extends Component {

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
            endpointPush: "",
            loginPush: "",
            motDePassePush: "",
            motDePassePushConfirmation: "",
            urlPush: "",
        };
    };

    _estFicheOuverteEnModeCreation = () => {
        return !this.props.idSociete;
    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement en cours..."
        });

        DataSociete._chargementSociete(this.props.idSociete)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const societe = responseFetch.reponseAPIobjet;
                    const { endpointPush, loginPush, motDePassePush, urlPush } = societe;
                    const stateTemp = { endpointPush, loginPush, motDePassePush, motDePassePushConfirmation: motDePassePush, urlPush };
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, stateTemp, this._onVerificationFormulaire);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                }
            });
    };

    _mettreAJourParametres = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Mise à jour des paramètres en cours..."
        });

        const { idSociete } = this.props;
        const { endpointPush, loginPush, motDePassePush, motDePassePushConfirmation, urlPush } = this.state;
        const parametresPush = { idSociete, endpointPush, loginPush, motDePassePush, motDePassePushConfirmation, urlPush };
        DataSociete._onMiseAJourParametresPush(parametresPush)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, {});
                    this.props.onMiseAJour();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                }
            });

    };

    _onOpen = () => {
        this._chargementDonnees();
    };

    _onRenderFooterContent = () => {
        const { onActiveBoutonEnregistrer } = this.state;
        return <Stack horizontal gap={8}>
            <PrimaryButton onClick={this._mettreAJourParametres} disabled={!onActiveBoutonEnregistrer}>Valider</PrimaryButton>
            <DefaultButton onClick={this.props.onDismiss}>Fermer</DefaultButton>
        </Stack>;
    };

    _onVerificationFormulaire = () => {
        const { idSociete } = this.props;
        const { endpointPush, loginPush, motDePassePush, motDePassePushConfirmation, urlPush } = this.state;
        const parametresPush = { idSociete, endpointPush, loginPush, motDePassePush, motDePassePushConfirmation, urlPush };
        Immocom.fiche()._validationFormulaire(this, "ParametresPush", parametresPush, this._estFicheOuverteEnModeCreation() ? "Création" : "Modification");
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;

        return <Panel
                closeButtonAriaLabel="Fermer"
                headerText={"Paramètres Push"}
                isOpen={isOpen}
                onDismiss={onDismiss}
                onOpen={this._onOpen}
                onRenderFooterContent={this._onRenderFooterContent}
                type={PanelType.smallFixedFar}
            >

                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />

                {
                    [
                        { label: "URL Push", attr: "urlPush" },
                        { label: "Endoint Push", attr: "endpointPush" },
                        { label: "Login Push", attr: "loginPush" },
                        { label: "Mot de passe Push", attr: "motDePassePush", type: "password" },
                        { label: "Confirmation du mot de passe", attr: "motDePassePushConfirmation", type: "password" },
                    ].map((fieldProps) => {
                        const { attr, label, type } = fieldProps;
                        return <EUITextField
                            key={attr}
                            label={label}
                            maxLength={MaxLengths.societe[attr]}
                            onDelayedChange={(event, newValue) => this.setState({ [attr]: newValue }, this._onVerificationFormulaire)}
                            type={type || "text"}
                            value={this.state[attr]}
                        />;
                    })
                }

            </Panel>;

    };

};